/**
 * Signals, not values: the mount rebuilds its inputs when the selected stage changes, and the board
 * must see the new scope without being re-created.
 */
import { ActivityEntityName } from '@jms/model';
import type { ItemBrowserAddAdapter } from '@workbuddy/entities/shared/item.browser.dialog';
import type { EmbeddedItemHostParams } from '@workbuddy/surfaces/embedded-item';
import type { EntityBoardContext } from '@workbuddy/ui/v2/blocks/entity.board';

/** One const because two things must agree: the board's `recordScopes` and the walker into a row. */
export const JOB_TEMPLATE_ITEM_SCOPE = 'template.workOrders.codes';

/** Board rows cache key. Every write invalidates it, so the commands must not spell it apart. */
export const JOB_TEMPLATE_ITEM_QUERY_KEY = [ActivityEntityName.JobTemplateItem, 'items'];

export interface JobTemplateItemBoardParams extends EmbeddedItemHostParams {
  /** Every read and write is addressed by it: a job template has many stages, and the tab is per stage. */
  readonly stage: () => { _id: string; name?: string } | null;
  /** Tenant setting: when true the money cells lead with the line extension rather than the unit price. */
  readonly showAdditionalLineFields: () => boolean;
  /** False while the record is readonly or the user lacks Manage — Add / Edit / Delete stay hidden. */
  readonly writable: () => boolean;
  /** Host refresh after any mutation; the job template record carries the items it just changed. */
  readonly itemsChanged: () => void;
  /** On `params` because a custom create operation has no per-entity provider hook. */
  readonly itemBrowser?: () => ItemBrowserAddAdapter;
}

export type JobTemplateItemBoardContext = EntityBoardContext & {
  readonly params: JobTemplateItemBoardParams;
};
